import {FormControl, FormHelperText, FormLabel, Input} from '@chakra-ui/react';

import {useFormContext} from 'react-hook-form';

import {QuestionProps} from './question';

export function NumberQuestion(props: Readonly<QuestionProps>) {
  const {question} = props;
  const {register} = useFormContext();

  return (
    <FormControl key={question.id}>
      <FormLabel>{question.title}</FormLabel>
      <Input type='number' {...register(question.id)} />
      <FormHelperText>{question.description}</FormHelperText>
    </FormControl>
  );
}
